export const enErrors = {
	"http-login-error": "Can't connect to the server",
};
